import { showErrorMessage } from '@eltoro-ui/components'
import { V1Pixel } from 'next-gen-sdk'
import { ApiFactory } from 'apiFactory'

export const createPixel = async (
  orgId: string,
  incomingPixel: Partial<V1Pixel>,
) => {
  const token = localStorage.getItem('eltoro_token')
  const apis = ApiFactory(token)
  const { webToHomeAPI } = apis
  if (!webToHomeAPI) return
  try {
    const pixel = await webToHomeAPI.advertisingPlatformServiceCreatePixel(
      {
        ...incomingPixel,
        orgId,
      },
      orgId,
    )
    return pixel
  } catch (error) {
    // @ts-ignore
    showErrorMessage('Error creating pixel', error?.message || '')
  }
}
